import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Image } from 'primeng/image';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Voiture, VoitureResponse } from '../modele/voiture';
import { AppelapiService } from './appelapi.service';

@Injectable()
export class VoitureService {

  constructor(private http: HttpClient, private api: AppelapiService) { }

  getProducts(): Promise<Voiture[]> {
    return this.http.get<any>('assets/voiture.json')
      .toPromise()
      .then(res => <Voiture[]>res.data)
      .then(data => { return data; });
  }

  getVoituresApi(): Observable<VoitureResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        'x-api-key': 'vo6U39MUy331hwaOPzzNw5MT6CUUuoowT7xMxEHa',
      })
    }

    return this.api.get<any>(`${environment.lien.api.voitures}`, null, httpOptions);
  }
}